var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 10.5v-1a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v1m6-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
export default SvgUser;